import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import broRatings from "../../../../src/data/articles/cube-prospective-the-brothers-war/bro-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  broRatings,
  ProspectiveIntro,
  React
};